export enum FormFieldKeys {
  guests = 'guests',
  specialOccasions = 'specialOccasions',
  additionalInfo = 'additionalInfo',
}
